module.exports = __webpack_public_path__ + "img/2.cd4cf25e.png";